<template>
	<div class="app-nav-top">
		<nav>
			<ul class="menu">
				<li>
					<router-link to="/index/prices">Prices</router-link>
				</li>
				<li>
					<router-link to="/index/terms">Terms and Conditions</router-link>
				</li>
				<li>
					<router-link to="/console/">Console</router-link>
				</li>
			</ul>
		</nav>
	</div>
</template>

<script>
import LogoHeader from '../shared/LogoHeader';

export default {
	name: "IndexNavigation",
	components: {
		LogoHeader
	}
};
</script>